import * as api from '../connectivity/api.files';
import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import _ from 'lodash';

let fileDownload = require('react-file-download');


export function* doRequestFileDownload(action) {
    yield put(showLoading());

    try{
        const file = yield call(api.downloadFile, action.payload.file_id);

        yield put({
            type: types.FILE__DOWNLOAD__REQUEST__SUCCEEDED,
            file: file,
            file_name : action.payload.file_name
        });
    } catch (e) {
        yield put({
            type: types.FILE__DOWNLOAD__REQUEST__FAILED,
            files: action.payload,
            message: e.message
        });
    }

    yield put(hideLoading());
}

export function* doRequestFileUpload(action) {
    try{
        const file = yield call(api.uploadFile, action.payload);

        yield put({
            type: types.FILE__UPLOAD__REQUEST__SUCCEEDED,
            file: file
        });
    } catch (e) {
        if (e.statusCode === 400) {
            yield put({
                type: types.FILE__UPLOAD__BAD__REQUEST,
                files: action.payload,
                data: e.data
            });
        } else {
            yield put({
                type: types.FILE__UPLOAD__REQUEST__FAILED,
                files: action.payload,
                message: e.message
            });
        }
    }
}

export function* doRequestFileDownloadSucceeded(action) {
    yield (fileDownload(action.file, action.file_name));

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file_name+" downloaded",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestFileDownload'
        }
    });
}

export function* doRequestFileDownloadFailed() {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Download failed",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestFileDownload'
        }
    });
}

export function* doRequestFileUploadSucceeded(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file.name+" uploaded successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestFileUpload'
        }
    });
}

export function* doRequestFileUploadFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File upload failed",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestFileUpload'
        }
    });
}

export function* doRequestFileUploadBadRequest(action) {
    if (action.data && action.data.form && action.data.form.children) {
        let {form} = action.data,
            fields = _.omitBy(
                _.mapValues(form.children, (field) => {
                    return field.errors;
                }),
                _.isNil
            )
        ;

        for (let errors in fields) {
            for (let i=0;i<fields[errors].length;i++) {
                yield put({
                    type: types.ADD_NOTIFICATION,
                    payload: {
                        message: fields[errors][i],
                        level: 'error'
                    }
                });
            }
        }
    }
}

export function* doRequestFileDelete(action) {
    yield put(showLoading());

    try{
        const file = yield call(api.removeFile, action.payload.file_id);

        yield put({
            type: types.FILE__DELETE__REQUEST__SUCCEEDED,
            file: file
        });
    } catch (e) {
        yield put({
            type: types.FILE__DELETE__REQUEST__FAILED,
            files: action.payload,
            message: e.message
        });
    }

    yield put(hideLoading());
}

export function* doRequestFileDeleteSucceeded(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file.name+" deleted",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestFileDelete'
        }
    });
}

export function* doRequestFileDeleteFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File delete failed",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestFileDelete'
        }
    });
}


export function* watchRequestFileUpload() {
    yield* takeEvery(types.FILE__UPLOAD__REQUESTED, doRequestFileUpload);
}

export function* watchRequestFileUploadSucceeded() {
    yield* takeEvery(types.FILE__UPLOAD__REQUEST__SUCCEEDED, doRequestFileUploadSucceeded);
}

export function* watchRequestFileUploadFailed() {
    yield* takeEvery(types.FILE__UPLOAD__REQUEST__FAILED, doRequestFileUploadFailed);
}

export function* watchRequestFileUploadBadRequest() {
    yield* takeEvery(types.FILE__UPLOAD__BAD__REQUEST, doRequestFileUploadBadRequest);
}

export function* watchRequestFileDownload() {
    yield* takeEvery(types.FILE__DOWNLOAD__REQUESTED, doRequestFileDownload);
}

export function* watchRequestFileDownloadSucceeded() {
    yield* takeEvery(types.FILE__DOWNLOAD__REQUEST__SUCCEEDED, doRequestFileDownloadSucceeded);
}

export function* watchRequestFileDownloadFailed() {
    yield* takeEvery(types.FILE__DOWNLOAD__REQUEST__FAILED, doRequestFileDownloadFailed);
}


export function* watchRequestFileDelete() {
    yield* takeEvery(types.FILE__DELETE__REQUESTED, doRequestFileDelete);
}

export function* watchRequestFileDeleteSucceeded() {
    yield* takeEvery(types.FILE__DELETE__REQUEST__SUCCEEDED, doRequestFileDeleteSucceeded);
}

export function* watchRequestFileDeleteFailed() {
    yield* takeEvery(types.FILE__DELETE__REQUEST__FAILED, doRequestFileDeleteFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/files.saga.js
 **/